import './styles.css';
import { el } from './ui/dom';
import { createTabs } from './ui/tabs';
import { createFormatView } from './ui/formatView';
import { createDiffView } from './ui/diffView';
import { createTreeView } from './ui/treeView';

function mount(): void {
  const root = document.getElementById('app');
  if (!root) return;

  const header = el('header', { class: 'app-header' }, [
    el('div', { class: 'brand' }, [
      el('h1', {}, ['JSON Studio']),
      el('span', { class: 'tagline' }, ['Format · Diff · Validate']),
    ]),
    el('div', { class: 'privacy' }, [
      el('span', { class: 'dot' }, []),
      'Runs entirely in your browser — your JSON never leaves this device.',
    ]),
  ]);

  const tabs = createTabs([
    { id: 'format', label: 'Format & Validate', render: createFormatView },
    { id: 'tree', label: 'Tree', render: createTreeView },
    { id: 'diff', label: 'Diff', render: createDiffView },
  ]);

  const footer = el('footer', { class: 'app-footer' }, [
    el('span', {}, ['No uploads. No tracking. Open a tab and paste your JSON.']),
  ]);

  root.replaceChildren(header, tabs, footer);
}

mount();
